/**
 * コンテンツが画面の高さより小さければフッターを下部に固定
 */
const fixFooterToBottom = () => {
    const main = document.querySelector('.js_main');
    const footer = document.querySelector('.js_footer');
    if (!main || !footer) return;

    const doWhenLoaded = () => {
        const className = 'is_fixed'; //footerに付与するクラス名
        const contsH = main.clientHeight + footer.clientHeight; //コンテンツの高さ

		if (contsH < window.innerHeight) {
			footer.classList.add(className);
		} else {
            footer.classList.remove(className);
		}
    }

    window.addEventListener('load', doWhenLoaded);
    window.addEventListener('resize', doWhenLoaded);
}

export default fixFooterToBottom;